(function ($) {
	if ($('.accordion-list-wrapper .accordion-parent-item-wrapper').length > 0) {

		$('.accordion-list-wrapper .accordion-parent-title').unbind().bind('click', function () {

		  let _this = $(this);
		  let _parent = _this.parent('.accordion-parent-item-wrapper');
      event.stopPropagation();

      _parent.toggleClass('active');
      if(_parent.hasClass('active')) {
        _this.next('.accordion-content-items-wrapper').stop(true).slideDown(300);
        _this.next('.accordion-content-items-wrapper').addClass('active');
      }
      else {
        _this.next('.accordion-content-items-wrapper').stop(true).slideUp(300);
        _this.next('.accordion-content-items-wrapper').removeClass('active');
      }

			// $('.accordion-content-items-wrapper').stop(true).slideUp(300);
			// if ($(this).hasClass('active')) {
			// 	$(this).removeClass('active');
			// } else {
      //   $('.accordion-list-wrapper .accordion-parent-item-wrapper').removeClass('active');
      //   $('.accordion-content-item-wrapper').removeClass('active');
      //   $(this).addClass('active');
      //   $('.accordion-content-items-wrapper', this).stop(true).slideDown(300);
      // }
		});

    $('.accordion-list-wrapper .accordion-title').unbind().bind('click', function () {

      let _this = $(this);
      event.stopPropagation();

      _this.toggleClass('active');
      if(_this.hasClass('active')) {
        _this.next('.accordion-content').stop(true).slideDown(300);
      }
      else {
        _this.next('.accordion-content').stop(true).slideUp(300);
      }

      // _this.next('.accordion-content').stop(true).slideUp(300);
      // if (parent.hasClass('active')) {
      //   parent.removeClass('active');
      // } else {
      //   $('.accordion-content-item-wrapper').removeClass('active');
      //   parent.addClass('active');
      //   _this.next('.accordion-content').stop(true).slideDown(300);
      // }
    });

		$('.m__month-title').on('click', function () {

		  $(this).toggleClass('active');

		  if($(this).hasClass('active')) {
		    $(this).next('.m__items').stop(true).slideDown(300);
      }
		  else {
        $(this).next('.m__items').stop(true).slideUp(300);
      }

    });
	}
})(jQuery);
